module.exports = __webpack_public_path__ + "static/media/check-in.bbc71cca.svg";